import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "@/components/motion";
import { img } from "@/lib/gallery";

export const WhyThree = () => {
  const { t } = useI18n();
  const w = t.why3;
  return (
    <section className="bg-[var(--navy)] py-24 lg:py-32" data-testid="why3-section">
      <div className="container-x grid gap-14 lg:grid-cols-12 lg:items-center">
        <div className="chamfer relative aspect-[4/3] overflow-hidden lg:col-span-6">
          <img src={img(16)} alt="3 MB300 dans un conteneur 40' dry" className="h-full w-full object-cover" />
          <span className="absolute left-5 top-5 bg-[#070C1A]/80 px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.14em] text-[var(--gold)]">3 × MB300 → 1 × 40' dry</span>
        </div>
        <div className="lg:col-span-6">
          <SectionHead index="05" eyebrow={w.eyebrow} title={w.title} />
          <Reveal delay={0.1}><p className="mt-6 text-[var(--steel)]">{w.text}</p></Reveal>
          <ul className="mt-8 grid grid-cols-2 gap-px bg-white/10 sm:grid-cols-3">
            {w.items.map((x, i) => (
              <li key={x} className="bg-[var(--navy)] p-4">
                <span className="font-mono text-[11px] text-[var(--gold)]">{String(i + 1).padStart(2, "0")}</span>
                <p className="mt-1 font-semibold">{x}</p>
              </li>
            ))}
          </ul>
          <Reveal delay={0.15}>
            <p className="font-display mt-10 text-3xl font-black uppercase leading-[0.95] sm:text-4xl" data-testid="why3-slogan">
              {w.slogan[0]}<br /><span className="text-[var(--gold)]">{w.slogan[1]}</span>
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
